import { useUserTabEditPermissionDisabled } from "../../../../lib/usersPermissions";
import SimpleBoxDisplay from "../../../common/SimpleBoxDisplay";
import NegotiationEntirySearchAndSet from "./entity/NegotiationEntirySearchAndSet";

export default function NegotiationEntityItem({primaryAttorney, entityType, sendIsLoading, reps}) {
    let userPermissionEdit = !useUserTabEditPermissionDisabled('case_negotiation')

    return <>
        {primaryAttorney?.negotiator_type == entityType && <>
            {primaryAttorney?.negotiator_type && <>
                {primaryAttorney && primaryAttorney.all_reps && primaryAttorney.all_reps[reps]?.length > 1 ?                 
                <NegotiationEntirySearchAndSet primaryAttorney={primaryAttorney} entityType={entityType} rep={reps} sendIsLoading={sendIsLoading} hasValue={`${primaryAttorney?.negotiator?.first_name} ${primaryAttorney?.negotiator?.last_name}`} hasLabel={'Negotiator'} negociator={primaryAttorney?.negotiator} contact={primaryAttorney?.negotiator?.contact_information} userPermissionEdit={userPermissionEdit}/> 
                :          
                <SimpleBoxDisplay label={'Negotiator Name'} value={`${primaryAttorney?.negotiator?.first_name} ${primaryAttorney?.negotiator?.last_name}`} contact_info={primaryAttorney?.negotiator?.contact_information}/>
                }
            </>}
        </>}    

        {primaryAttorney?.negotiator_type !== entityType && <>
            <NegotiationEntirySearchAndSet primaryAttorney={primaryAttorney} entityType={entityType} rep={reps} sendIsLoading={sendIsLoading} userPermissionEdit={userPermissionEdit}/>
        </>} 
    </>
}